import { Component, OnInit } from '@angular/core';
import { AuthService, StoreService } from '@common/core/services';
import { BitfMatSidenavService } from '@common/libs/bitforce/core/services/sidenav/material/bitf-mat-sidenav.service';
import { AppSessionService } from '@web/core/services';

@Component({
  selector: 'cci-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss'],
})
export class SidenavMenuComponent implements OnInit {
  constructor(
    public storeService: StoreService,
    private authService: AuthService,
    public bitfMatSidenavService: BitfMatSidenavService,
    public appSessionService: AppSessionService
  ) {}

  ngOnInit(): void {}

  onSignOut() {
    this.authService.signOut();
  }
}
